import React from "react";

import MarkdownPage from "../components/MarkdownPage";

const AboutUs = () => {
  return (
    <MarkdownPage url="https://raw.githubusercontent.com/REmatchChile/REmatch-docs/main/what-is-rematch.md" />
  );
};

export default AboutUs;
